import { Component, OnInit, ChangeDetectorRef, AfterViewInit, OnDestroy } from '@angular/core';
import { HROUTES } from './navigation-routes.config';
import { LayoutService } from '../services/layout.service';
import { ConfigService } from '../services/config.service';
import { Subscription } from 'rxjs';
import { Router, Params } from '@angular/router';
import { AuthService } from '../auth/auth.service';


@Component({
  selector: 'app-horizontal-menu',
  templateUrl: './horizontal-menu.component.html',
  styleUrls: ['./horizontal-menu.component.scss']
})
export class HorizontalMenuComponent implements OnInit, AfterViewInit, OnDestroy {

  public menuItems: any[];
  public config: any = {};
  level: number = 0;
  transparentBGClass = "";
  menuPosition = 'Side';
  private navigationTargetCache = new Map<string, { path: string; queryParams: Params | null }>();

  layoutSub: Subscription;

  constructor(public authService: AuthService,
    private layoutService: LayoutService,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,
    private router: Router) {
    this.config = this.configService.templateConf;
  }

  ngOnInit() {
    this.menuItems = HROUTES;
  }

  ngAfterViewInit() {

    this.layoutSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();

    })
  }

  loadLayout() {

    if (this.config.layout.menuPosition && this.config.layout.menuPosition.toString().trim() != "") {
      this.menuPosition = this.config.layout.menuPosition;
    }


    if (this.config.layout.variant === "Transparent") {
      this.transparentBGClass = this.config.layout.sidebar.backgroundColor;
    }
    else {
      this.transparentBGClass = "";
    }

  }

  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
  }

  getInternalRoutePath(path: string): string {
    return this.getNavigationTarget(path).path;
  }

  getInternalQueryParams(path: string): Params | null {
    return this.getNavigationTarget(path).queryParams;
  }

  private getNavigationTarget(rawPath: string): { path: string; queryParams: Params | null } {
    const cacheKey = rawPath || '';
    const cached = this.navigationTargetCache.get(cacheKey);

    if (cached) {
      return cached;
    }

    const trimmedPath = (rawPath || '').trim();

    if (trimmedPath === '') {
      const emptyTarget = { path: '', queryParams: null };
      this.navigationTargetCache.set(cacheKey, emptyTarget);
      return emptyTarget;
    }

    const questionMarkIndex = trimmedPath.indexOf('?');
    const rawInternalPath = questionMarkIndex >= 0 ? trimmedPath.substring(0, questionMarkIndex) : trimmedPath;
    const rawQueryString = questionMarkIndex >= 0 ? trimmedPath.substring(questionMarkIndex + 1) : '';
    const normalizedPath = rawInternalPath.startsWith('/') ? rawInternalPath : `/${rawInternalPath}`;
    const queryParams = this.parseQueryParams(rawQueryString);

    const target = { path: normalizedPath, queryParams };
    this.navigationTargetCache.set(cacheKey, target);

    return target;
  }

  private parseQueryParams(queryString: string): Params | null {
    if (!queryString) {
      return null;
    }

    const params: Params = {};
    const parsedQuery = new URLSearchParams(queryString);

    parsedQuery.forEach((value, key) => {
      const currentValue = params[key];

      if (currentValue === undefined) {
        params[key] = value;
      } else if (Array.isArray(currentValue)) {
        currentValue.push(value);
      } else {
        params[key] = [currentValue, value];
      }
    });

    return Object.keys(params).length > 0 ? params : null;
  }
}
